import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Flex, Typography } from 'antd'
import { path } from 'src/libs'
import { BudgetRequest } from 'src/pages/budget/budgetRequests/types'
import { FormRequestPayment } from './component'

type RequestWidgetProps = {
  request: BudgetRequest
}

export const RequestPaymentWidget = ({ request }: RequestWidgetProps) => {
  const navigate = useNavigate()
  const { Title, Text } = Typography

  return (
    <Flex vertical gap="middle">
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  fontSize: 16,
                }}
                onClick={() => {
                  navigate(path.budget.budgets.entry())
                }}
              >
                Заявки на бюджет
              </Text>
            ),
          },
          {
            title: (
              <Text type="secondary" style={{ fontSize: 16 }}>
                Заявка на оплату бюджета <strong>№{request.id}</strong>
              </Text>
            ),
          },
        ]}
      />
      <Title level={1} style={{ marginBottom: 0 }}>
        Создание заявки на оплату
      </Title>
      <FormRequestPayment request={request} />
    </Flex>
  )
}
